import React from "react";
import { Backup } from "./backup";

export interface BackupViewProps {
    collections: string[];
}

export function BackupView({ collections }: BackupViewProps) {
    return (
        <Backup collections={collections} />
    );
}